import { z } from "zod";

import { ReviewEntity } from "~/entities/review/model";
import { Response } from "~/shared/api";

const zOutSchema = ReviewEntity.zSchema
  .pick({
    id: true,
    rating: true,
  })
  .extend({
    pros: ReviewEntity.zSchema.shape.pros.nullable(),
    cons: ReviewEntity.zSchema.shape.cons.nullable(),
    reviewContent: ReviewEntity.zSchema.shape.text.nullable(),
    firstName: ReviewEntity.zSchema.shape.customer.shape.firstName.nullable(),
    lastName: ReviewEntity.zSchema.shape.customer.shape.lastName.nullable(),
    createdAt: z.string().datetime(),
  });
type OutSchema = z.infer<typeof zOutSchema>;

const zOutSchema2 = zOutSchema
  .merge(
    ReviewEntity.zSchema.pick({
      isApproved: true,
    }),
  )
  .extend({
    contactEmail: ReviewEntity.zSchema.shape.customer.shape.email.nullable(),
    contactPhone: ReviewEntity.zSchema.shape.customer.shape.phone.nullable(),
    orderNumber: ReviewEntity.zSchema.shape.orderNumber.nullable(),
  });
type OutSchema2 = z.infer<typeof zOutSchema2>;

const zRes401 = Response.Schema.zUnsuccessful(401);

export { zOutSchema, zOutSchema2, zRes401 };
export type { OutSchema, OutSchema2 };
